import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { SearchableEntityActionService } from '../searchable-entity-action.service';
import { SimpleEntityDataService } from './simple-entity-data.service';
import { SimpleEntityButtonService } from './simple-entity-button.service';
import { SimpleEntityDataEditorService } from './simple-entity-data-editor.service';
import { SimpleEntityBackendService } from './simple-entity-backend.service';
import { Observable } from 'rxjs/Observable';
import { ValidatorService } from '../../validator.service';
import { Condition } from '../../../search/models/search-filter-model';
import { SearchEvent } from '../../../search/models/search-event';
import { DELETE_ROW_EVENT } from '../../../search/search-constants';
import { LocalPagedSearchService } from '../../../search/localpaged-search.service';

@Injectable()
export class SimpleEntityActionService extends SearchableEntityActionService {

  protected dataService: SimpleEntityDataService;
  protected buttonService: SimpleEntityButtonService;
  protected backendService: SimpleEntityBackendService;
  protected dataEditor: SimpleEntityDataEditorService;
  protected validatorService: ValidatorService;
  public editedData: Array<any> = [];
  public selectedData: Array<any> = [];

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public setDependentServices(dataService, buttonService, dataEditor, backendService) {
    this.dataService = dataService;
    this.buttonService = buttonService;
    this.dataEditor = dataEditor;
    this.backendService = backendService;
  }

  public editPage() {
    if (this.dataService.displayMode === 'V') {
      this.dataService.setDisplayMode('E');
      this.buttonService.initializeSearchPageButtons();
    }
  }

  // Method to delete
  /*  public delete() {
      const selectedLineItems = [];
      this.selectedData = this.dataService.searchService.getPagedData().pageRows.filter((row: any) => {
        return row.isSelected;
      });
      const primaryIdProperty = this.dataService.searchParams.idProperty;
      this.selectedData.forEach((row: any, index: any) => {
        const selectedLineItem = [];
        Object.keys(row.cells).forEach((property: any) => {
          const cell = row.cells[property];
          if (property === primaryIdProperty) {
            selectedLineItem.push({ cName: property, cVal: cell.cVal });
          }
        });
        selectedLineItems.push({ rIdx: index, cells: selectedLineItem });
      });

      if (selectedLineItems.length === 0) {
        this.alertService.clearAll().error(this.resourceService.get(this.errorMsg));
        return;
      }
      const request = {
        'detailType': this.dataService.searchParams.tableId,
        'detailItems': selectedLineItems
      };
      this.confirmDialogService.confirmDialog(this.resourceService.get(this.dialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            this.backendService.delete(request).subscribe((resp: any) => {
              if (resp['statusCode'] && resp['statusMessage']) {
                if (resp['statusCode'] === 200) {
                  this.dataService.searchService.performSearch();
                  // this.alertService.success(resp['statusMessage']);
                  this.alertService.success(this.resourceService.get(this.successMsg));
                }
              } else {
                if (resp.error) {
                  this.alertService.clearAll();
                  this.alertService.error(this.resourceService.translateServerResponse(resp.error));
                }
              }
            }, (error: any) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
            });
          }
        });
    }

    // Method to save equipment page
    public savePage(): Observable<any> {
      let lineItems: Array<any>;
      lineItems = this.dataService.getAllLineItems();
      // set the line item properties
      if (this.dataService.displayMode === 'E') {
        lineItems = this.dataService.getModifiedLineItems();
      }
      // adding the warning so as to avoid saving when no modifications are done to the entity and trying to save.
      if (lineItems.length === 0) {
        this.errorMsg = 'msg_no_mod';
        this.alertService.clearAll().warn(this.resourceService.get(this.errorMsg));
        this.dataService.searchService.clearMarkerFlags();
        // this.clearEditedFlags();
        this.navService.preventNavigation = false;
        this.dataService.setDisplayMode('V');
        this.buttonService.initializeSearchPageButtons();
        return;
      }
      // added to validate user entered data
      if (this.validateUserEnteredData()) {
      return this.backendService.saveEntity(lineItems)
        .map((response) => {
          return response;
        });
      }
    }

  /  public validateUserEnteredData() {
      // added to validate the fields of line items
      const validateLineItemsErr = this.validatorService.validateMultipleRows(this.dataService.getSearchService().
        getMetadata(), this.dataService.getSearchService().getPagedData());
      if (validateLineItemsErr) {
        return false;
      } else {
        return true;
      }
    } */

  // Method to delete
  public delete() {
    // if locally paginated we need to use client side local paged search service
    if (this.dataService.searchParams.paginateLocally) {
      const rowIndexArray: any[] = [];
      this.dataService.searchService.getPagedData().pageRows.forEach((row: any, index: any) => {
        if (row.isSelected === true) {
          rowIndexArray.push(index);
        }
      });
      // check wether the user selects atleast one record
      if (rowIndexArray.length > 0) {
        const searchService = <LocalPagedSearchService>this.dataService.searchService;
        this.confirmDialogService.confirmDialog(this.resourceService.get(this.dialogMsg))
          .subscribe((isConfirmed: any) => {
            try {
              for (let index = rowIndexArray.length - 1; index >= 0; index--) {
                searchService.deleteRowsFromModel(rowIndexArray[index]);
              }
              this.dataService.searchService.performSearch();
              const evt = new SearchEvent(DELETE_ROW_EVENT);
              this.dataService.searchService.publishEvent(evt);
              this.alertService.clearAll().success(this.resourceService.get(this.successMsg));
            } catch (e) {
              this.alertService.clearAll().error(this.resourceService.get(this.errorMsg));
            }
          });
      } else {
        const select_one_row = 'Please Select Atleast One Row To Delete';
        this.alertService.clearAll().error(this.resourceService.get('select_one_row'));
      }
    } else {
      const selectedLineItems = [];
      this.selectedData = this.dataService.searchService.getPagedData().pageRows.filter((row: any) => {
        return row.isSelected;
      });
      this.selectedData.forEach((row: any, index: any) => {
        const selectedLineItem = [];
        Object.keys(row.cells).forEach((property: any) => {
          const cell = row.cells[property];
          selectedLineItem.push({ cName: property, cVal: cell.cVal });
        });
        const request = {
          'moduleProperties': selectedLineItem,
          'screenType': this.dataService.searchParams.tableId
        };
        selectedLineItems.push(request);
      });
      if (selectedLineItems.length === 0) {
        this.alertService.clearAll().error(this.resourceService.get(this.errorMsg));
        return;
      }
      this.confirmDialogService.confirmDialog(this.resourceService.get(this.dialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            this.backendService.delete(selectedLineItems).subscribe((resp: any) => {
              if (resp['statusCode'] && resp['statusMessage']) {
                if (resp['statusCode'] === 200) {
                  this.dataService.searchService.performSearch();
                  // this.alertService.success(resp['statusMessage']);
                  this.alertService.success(this.resourceService.get(this.successMsg));
                }
              } else {
                if (resp.error) {
                  this.alertService.clearAll();
                  this.alertService.error(this.resourceService.get(resp.error));
                }
              }
            }, (error: any) => {
              this.alertService.clearAll().error(this.resourceService.get(error));
            });
          }
        });
    }
  }

  // Method to save area page
  public savePage(): Observable<any> {
    let lineItems: Array<any>;
    if (this.dataService.searchParams.paginateLocally) {
      lineItems = this.dataService.searchService.fullData;
    } else if (this.dataService.displayMode === 'E') {     // set the line item properties
      lineItems = this.dataService.getModifiedLineItems();
    } else {
      lineItems = this.dataService.getAllLineItems();
    }

    let requestItems: Array<any>;
    // adding the warning so as to avoid saving when no modifications are done to the entity and trying to save.
    if (lineItems.length === 0) {
      this.errorMsg = 'msg_no_mod';
      this.alertService.clearAll().warn(this.resourceService.get(this.errorMsg));
      this.dataService.searchService.clearMarkerFlags();
      // this.clearEditedFlags();
      this.navService.preventNavigation = false;
      this.dataService.setDisplayMode('V');
      this.buttonService.initializeSearchPageButtons();
      return;
    }
    // format the modified line items in the required request format
    requestItems = this.getCellValuesList(lineItems);
    // added to validate mandatory fields
    const validationErrorMsg = this.validateLineItems(requestItems);
    if (validationErrorMsg) {
      this.errorMsg = validationErrorMsg;
      this.alertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return;
    }
    if (this.validateUserEnteredData()) {
      return this.backendService.saveEntity(requestItems)
        .map((response) => {
          return response;
        });
    }
  }

  public validateUserEnteredData() {
    // added to validate the fields of line items
    const validateLineItemsErr = this.validatorService.validateMultipleRows(this.dataService.getSearchService().
      getMetadata(), this.dataService.getSearchService().getPagedData());
    if (validateLineItemsErr) {
      return false;
    } else {
      return true;
    }
  }

  protected getCellValuesList(modifiedLineItems) {
    const requestList: Array<any> = [];
    let selectedLineItem;
    if (this.dataService.searchParams.paginateLocally) {
      modifiedLineItems.forEach((row: any, index: any) => {
        selectedLineItem = [];
        Object.keys(row.cells).forEach((property: any) => {
          const cell = row.cells[property];
          selectedLineItem.push({ cName: property, cVal: cell.cVal });
        });
        selectedLineItem.push({
          'cName': 'isNewItem',
          'cVal': true
        });
        const request = {
          'moduleProperties': selectedLineItem,
          'screenType': this.dataService.searchParams.tableId
        };
        requestList.push(request);
      });
    } else {
      modifiedLineItems.forEach((row: any, index: any) => {
        selectedLineItem = [];
        const isNewItem: boolean = (row.cells['isNewItem'] && row.cells['isNewItem'].cVal) ? true : false;
        let typeName = '';
        if (!isNewItem) {
          typeName = 'original_';
        }
        Object.keys(row.cells).forEach((property: any) => {
          const cell = row.cells[property];
          if ((cell.cValOrig !== undefined) && (cell.cValOrig !== cell.cVal)) {
            // [LFWM-2408] - no need to send addwho and editWho this will be added at backend
            if (property.toLowerCase() === 'addwho' || property.toLowerCase() === 'editwho') {
              return false;
            } else {
              selectedLineItem.push({ cName: typeName + property, cVal: cell.cValOrig });
              selectedLineItem.push({ cName: property, cVal: cell.cVal });
            }
          } else {
            // [LFWM-2408] - no need to send addwho and editWho this will be added at backend
            if (property.toLowerCase() === 'addwho' || property.toLowerCase() === 'editwho') {
              return false;
            } else {
              selectedLineItem.push({ cName: typeName + property, cVal: cell.cVal });
            }
          }
        });
        const request = {
          'moduleProperties': selectedLineItem,
          'screenType': this.dataService.searchParams.tableId
        };
        requestList.push(request);
      });
    }

    return requestList;
  }

  protected createDefaultSearchCondition(id) {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = 'VIEW';
    return defaultCondition;
  }

  // method used to validate the line items
  public validateLineItems(lineItems) {
    return null;
  }
  // Method to save area page
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  public savePageWithPrivilege(privilegeList: any): Observable<any> {
    let lineItems: Array<any>;
    if (this.dataService.searchParams.paginateLocally) {
      lineItems = this.dataService.searchService.fullData;
    } else if (this.dataService.displayMode === 'E') {     // set the line item properties
      lineItems = this.dataService.getModifiedLineItems();
    } else {
      lineItems = this.dataService.getAllLineItems();
    }

    let requestItems: Array<any>;
    // adding the warning so as to avoid saving when no modifications are done to the entity and trying to save.
    if (lineItems.length === 0) {
      this.errorMsg = 'msg_no_mod';
      this.alertService.clearAll().warn(this.resourceService.get(this.errorMsg));
      this.dataService.searchService.clearMarkerFlags();
      // this.clearEditedFlags();
      this.navService.preventNavigation = false;
      this.dataService.setDisplayMode('V');
      this.buttonService.initializeSearchPageButtons();
      return;
    }
    // format the modified line items in the required request format
    requestItems = this.getCellValuesListWithprivilege(lineItems, privilegeList);
    // added to validate mandatory fields
    const validationErrorMsg = this.validateLineItems(requestItems);
    if (validationErrorMsg) {
      this.errorMsg = validationErrorMsg;
      this.alertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return;
    }
    if (this.validateUserEnteredData()) {
      return this.backendService.saveEntityWithPrivilege(requestItems)
        .map((response) => {
          return response;
        });
    }
  }

  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  protected getCellValuesListWithprivilege(modifiedLineItems, privilegeList: any) {
    let privilege;
    let filteredCell;
    const requestList: Array<any> = [];
    let selectedLineItem;
    if (this.dataService.searchParams.paginateLocally) {
      modifiedLineItems.forEach((row: any, index: any) => {
        selectedLineItem = [];
        filteredCell = [];
        Object.keys(row.cells).forEach((property: any) => {
          const cell = row.cells[property];
          selectedLineItem.push({ cName: property, cVal: cell.cVal });
        });
        selectedLineItem.push({
          'cName': 'isNewItem',
          'cVal': true
        });
        if (row.cells['isNewItem'] && row.cells['isNewItem'].cVal === true) {
          filteredCell.push(row.cells);
        }
        if (filteredCell && filteredCell.length > 0) {
          privilege = privilegeList.filter((item: any) => {
            return item.endsWith('_add');
          });
        } else {
          privilege = privilegeList.filter((item: any) => {
            return item.endsWith('_edit');
          });
        }
        const request = {
          'moduleProperties': selectedLineItem,
          'screenType': this.dataService.searchParams.tableId,
          'privilege': privilege[0]
        };
        requestList.push(request);
      });
    } else {
      modifiedLineItems.forEach((row: any, index: any) => {
        selectedLineItem = [];
        filteredCell = [];
        const isNewItem: boolean = (row.cells['isNewItem'] && row.cells['isNewItem'].cVal) ? true : false;
        let typeName = '';
        if (!isNewItem) {
          typeName = 'original_';
        }
        Object.keys(row.cells).forEach((property: any) => {
          const cell = row.cells[property];
          if ((cell.cValOrig !== undefined) && (cell.cValOrig !== cell.cVal)) {
            // [LFWM-2408] - no need to send addwho and editWho this will be added at backend
            if (property.toLowerCase() === 'addwho' || property.toLowerCase() === 'editwho') {
              return false;
            } else {
              selectedLineItem.push({ cName: typeName + property, cVal: cell.cValOrig });
              selectedLineItem.push({ cName: property, cVal: cell.cVal });
            }
          } else {
            // [LFWM-2408] - no need to send addwho and editWho this will be added at backend
            if (property.toLowerCase() === 'addwho' || property.toLowerCase() === 'editwho') {
              return false;
            } else {
              selectedLineItem.push({ cName: typeName + property, cVal: cell.cVal });
            }
          }
        });
        if (row.cells['isNewItem'] && row.cells['isNewItem'].cVal === true) {
          filteredCell.push(row.cells);
        }
        if (filteredCell && filteredCell.length > 0) {
          privilege = privilegeList.filter((item: any) => {
            return item.endsWith('_add');
          });
        } else {
          privilege = privilegeList.filter((item: any) => {
            return item.endsWith('_edit');
          });
        }
        const request = {
          'moduleProperties': selectedLineItem,
          'screenType': this.dataService.searchParams.tableId,
          'privilege': privilege[0]
        };
        requestList.push(request);
      });
    }

    return requestList;
  }



}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/searchable-entity/simple-entity/simple-entity-action.service.ts